import configService from "../../services/configService";
import haugazelService from "../../services/haugazelService";
import router from "../../router";

const getDefaultState = () => {
  return {
    ranges: [],
    simulationProducts: [],
    forcedProducts: null,
    featured: null,
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    setRanges(state, value) {
      state.ranges = value;
    },
    setSimulationProducts(state, value) {
      state.simulationProducts = value;
    },
    setForcedProducts(state, value) {
      state.forcedProducts = value;
    },
    setFeatured(state, value) {
      state.featured = value;
    },
    reset(state) {
      Object.assign(state, getDefaultState());
    }
  },
  actions: {
    async getPodium(context) {
      if(context.state.forcedProducts) {
        context.commit("setSimulationProducts", context.state.forcedProducts);
      } else {
        try {
          let podiumParams = await context.dispatch("getPodiumData");
          let response = await haugazelService.getPodium(podiumParams);
          context.dispatch("setSimulationProducts", response);
          context.dispatch("setRanges", response);
          const findFirstIsFeatured = response.find(range => range.isFeatured);
          if(findFirstIsFeatured) {
            context.dispatch("setFeatured", findFirstIsFeatured.range);
          }
        } catch (error) {
          throw error;
        }
      }
    },
    setRanges(context, products) {
      products = products.sort((a, b) => (a.order > b.order ? 1 : -1));
      let ranges = [...new Set(products.map(x => x.range))];

      context.commit("setRanges", ranges);
    },
    setSimulationProducts(context, products) {
      let electricityProducts = products.filter(
        product => product.energy === "electricity"
      );
      let gasProducts = products.filter(product => product.energy === "gas");

      let simulationProducts = {
        electricity: electricityProducts.map(item => {
          return item.hgzId;
        }),
        gas: gasProducts.map(item => {
          return item.hgzId;
        })
      };

      context.commit("setSimulationProducts", simulationProducts);
    },
    getPodiumData(context) {
      let podiumData = {
        customerType: context.rootState.contact.isPro ? "pro" : "resi",
        area: context.rootState.calculation.area
      };

      if (context.rootState.common.agentRef) {
        podiumData["agent"] = context.rootState.common.agentRef;
      }

      if(context.rootState.common.campaign) {
        podiumData["campaign"] = context.rootState.common.campaign;
      }

      if (router.currentRoute.query.campaign) {
        podiumData["campaign"] = router.currentRoute.query.campaign;
      }

      return podiumData;
    },
    setFeatured(context, value) {
      context.commit("setFeatured", value);
    }
  },
  getters: {
    rangesDesktop: state => {
      let ranges = state.ranges;

      if (ranges.length > 1) {
        let temp = ranges[0];
        ranges[0] = ranges[1];
        ranges[1] = temp;
      }

      return ranges;
    },
    rangesMobile: state => {
      return state.ranges.reverse();
    },
    isForcedProduct: state => {
      return state.forcedProducts !== null;
    },
    featured: state => {
      return state.featured;
    },
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/podium.js